import { Message } from 'element-react'
import {
    sendInvite as sendInviteFromRepository,
    selfActivationInvite,
} from '../../repositories/AdminRepository'

export const sendInvite = userId => {
    return sendInviteFromRepository(userId)
        .then(response => {
            Message({
                message: response.data.message,
                type: 'success',
                showClose: true,
                duration: 1200,
                customClass: 'el-message--success',
                iconClass: 'el-message__icon el-icon-circle-check',
            })
        })
        .catch(error => {
            Message({
                message: error.response.data.message,
                type: 'error',
                showClose: true,
                duration: 1200,
                customClass: 'el-message--error',
                iconClass: 'el-message__icon el-icon-circle-cross',
            })
        })
}

export const sendSelfActivationInvite = userId => {
    return selfActivationInvite(userId)
        .then(response => {
            Message({
                message: response.data.message,
                type: 'success',
                showClose: true,
                duration: 1200,
                customClass: 'el-message--success',
                iconClass: 'el-message__icon el-icon-circle-check',
            })
        })
        .catch(error => {
            Message({
                message: error.response.data.message,
                type: 'error',
                showClose: true,
                duration: 1200,
                customClass: 'el-message--error',
                iconClass: 'el-message__icon el-icon-circle-cross',
            })
        })
}
